module.exports = __webpack_public_path__ + "img/share8.42c14332.png";